const FALLBACK_FILE_NAME = 'roles.json';

/**
 * Reads the file name the server picked off a download response.
 *
 * The name is deliberately not rebuilt on the client: keeping it server-side is what makes every
 * export, at every level, named the same way.
 */
export function readDownloadFileName(headers: Record<string, unknown> | undefined): string {
  const disposition = headers?.['content-disposition'];
  if (typeof disposition !== 'string') {
    return FALLBACK_FILE_NAME;
  }

  // Handles both `filename="x.json"` and the RFC 5987 `filename*=UTF-8''x.json` form.
  const encoded = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(disposition);
  if (encoded?.[1]) {
    return decodeURIComponent(stripQuotes(encoded[1])) || FALLBACK_FILE_NAME;
  }

  const plain = /filename="?([^";]+)"?/i.exec(disposition);
  return plain?.[1]?.trim() || FALLBACK_FILE_NAME;
}

function stripQuotes(value: string): string {
  return value.trim().replace(/^"|"$/g, '');
}
